import ApiRequest from "../utils/ApiRequest";
import { bulkUploadModel } from "../utils/bulkUploadModel";

export default class SubCategory {
  static getAll = async () => {
    return await ApiRequest.set("v1/sub-categories/getallsubcategory", "GET");
  }

  static getById = async (id) => {
    return await ApiRequest.set(`v1/sub-categories/getbyid/${id}`, "GET");
  }

  static getByBookId = async (bookId) => {
    return await ApiRequest.set(`v1/sub-categories/books/${bookId}/subcategories`, "GET");
  }

  static create = async (body) => {
    return await ApiRequest.set(`v1/sub-categories/create`, "POST", body);
  }

  static edit = async (id, body) => {
    return await ApiRequest.set(`v1/sub-categories/update/${id}`, "PUT", body);
  }

  static delete = async (id) => {
    return await ApiRequest.set(`v1/sub-categories/delete/${id}`, "DELETE");
  }

  static bulkUpload = async (file, dryRun = false) => {
    return await bulkUploadModel('v1/sub-categories/').bulkUpload(file, dryRun);
  };

  static downloadTemplate = async () => {
    return await bulkUploadModel('v1/sub-categories/').downloadTemplate();
  };
}
